<template>
  <div>
    <p id="name">{{biz.name}}</p>
    <div id="industry-icons-container">
      <p v-show="biz.name" id="industry">
        {{industries.find(e => {return e.value === biz.industry}).text.toUpperCase()}}
      </p>
      <img v-show="biz.website" src="../assets/website.svg" class="icon" id="website" @click="openUrl(biz.website)">
      <img v-show="biz.instagram" src="../assets/instagram.svg" class="icon" id="instagram" @click="openUrl(biz.instagram)">
      <img v-show="biz.twitter" src="../assets/twitter.svg" class="icon" id="twitter" @click="openUrl(biz.twitter)">
      <img v-show="biz.facebook" src="../assets/facebook.svg" class="icon" id="facebook" @click="openUrl(biz.facebook)">
    </div>
    <div v-show="biz.name" id="container">
      <div id="left-side">
        <p class="title" id="address-title">ADDRESS</p>
        <p class="body" id="address">{{biz.address}}, {{biz.zip}}</p>
        <p class="title" id="years-title">YEARS IN BUSINESS</p>
        <p class="body" id="years">{{biz.years}}</p>
        <p class="title" id="employees-title"># OF EMPLOYEES</p>
        <p class="body" id="employees">{{biz.employees}}</p>
      </div>
      <div id="right-side">
        <p class="title" id="issues-title">ISSUES</p>
        <p class="body" id="issues" v-for="issue in biz.issues" :key="issue">
          {{biz.issues.length === 1 ? '' : '-'}} {{issues.find(e => {return e.value === issue}).text}}
        </p>
        <p class="title" id="help-title">WHAT HAPPENED & WHAT CAN HELP</p>
        <p class="body" id="help">{{biz.help}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {industries, issues} from '../utils/constants'

  export default {
    name: "BizInfo",
    data() {
      return {
        biz: {
          name: '',
          address: '',
          zip: '',
          years: '',
          employees: '',
          industry: 1,
          issues: [],
          help: '',
          website: '',
          instagram: '',
          facebook: '',
          twitter: ''
        },
        industries: industries,
        issues: issues,
      }
    },
    mounted() {
      this.$root.$on('updateBizInfo', data => {
        this.biz = data
      })
    },
    methods: {
      openUrl(url) {
        window.open(url)
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: white;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .3);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }
  p {
    font-family: "Avenir Next", openSans, serif;
    text-align: left;
    padding: 0;
    margin: 0;
  }
  #name {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 2.6vw;
    margin-right: 6px;
    color: black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #industry-icons-container {
    display: flex;
  }
  #industry {
    font-weight: bold;
    font-size: 1.3vw;
    color: #969696;
  }
  .icon {
    margin-right: 30px;
    cursor: pointer;
  }
  #website {
    margin-left: auto;
  }
  #container {
    display: flex;
  }
  #left-side {
    margin-top: 22px;
    padding-right: 2px;
    flex: 0 0 200px;
    height: 285px;
    border-right: 1px solid #DDDDDD;
  }
  #right-side {
    flex: 1;
    height: 285px;
    margin-top: 22px;
    padding-left: 20px;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .title {
    font-weight: bold;
    font-size: 1.2vw;
  }
  .body {
    margin-top: 5px;
    font-size: 1.4vw;
  }
  #years-title, #employees-title {
    margin-top: 18px;
  }
  #help-title {
    margin-top: 18px;
  }
  #address, #years, #employees {

  }
  #issues, #help {
    margin-right: 6px;
  }

  /*LARGE DESKTOPS*/
  @media only screen and (min-width: 1440px) {
    /*#name {*/
    /*  font-size: 30px;*/
    /*}*/
    /*#industry {*/
    /*  font-size: 15px;*/
    /*}*/
  }

  /*AVERAGE DESKTOPS*/
  @media only screen and (min-width: 1068px) {
    #name {
      font-size: 30px;
    }
    #industry {
      font-size: 15px;
    }
    .title {
      font-size: 14px;
    }
    .body {
      font-size: 16px;
    }
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #name {
      font-size: 18px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }
    #industry {
      font-size: 9px;
    }
    .icon {
      height: 13px;
      margin-right: 16px;
    }
    #left-side {
      margin-top: 15px;
      flex: 0 0 40%;
      height: 220px;
      border-right: 1px solid #DDDDDD;
    }
    #right-side {
      height: 220px;
    }
    .title {
      font-size: 9px;
    }
    .body {
      font-size: 10px;
    }
  }
</style>